import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import { ShipmentWithRelations } from '@/models/shipment';

import { ShipmentMessageTitle } from './ShipmentMessageTitle';

export const ArchivedMessage = ({
  shipment,
  hideIcon,
  className,
}: {
  shipment: ShipmentWithRelations;
  hideIcon?: boolean;
  className?: string;
}) => {
  return (
    <AlertBar
      type="error"
      size="large"
      hideIcon={hideIcon}
      className={className}
      title={
        <ShipmentMessageTitle shipment={shipment} showStatusDueAt={false}>
          <Trans id="shipment.archived-message.title">Shipment automatically archived</Trans>
        </ShipmentMessageTitle>
      }
    >
      <p>
        <Trans id="shipment.archived-message.text">
          This shipment has been automatically archived because all its items were also archived.
        </Trans>
      </p>
    </AlertBar>
  );
};
